import {EventsListView} from './events_list_view.js';
import {RoutesView} from './routes_view.js';
import {ClubMembersView} from './club_members_view.js';
import {EmbedLibraryView} from './embed_library_view.js';
import {ExperiencesView} from './experiences_view.js';
import {PoiLibraryView} from './poi_library_view.js';

rwgps.clubs.reactBindings = {}
;['events', 'routes', 'embed_library', 'experiences', 'poi_library', 'members', 'messages', 'settings'].forEach(page => {
  rwgps.clubs.reactBindings[page] = {
    onMount: function(el) {
      el.innerHTML = window.clubPages[page]
      rwgps.clubs.show.onMount(page)
    },
    onUnmount: function(el) {
      rwgps.clubs.show.onUnmount(page)
      el.innerHTML = ''
    }
  }
})

rwgps.ns('clubs.show', function() {
  var ns = this, MessageCommentView, ClubMessagesView, ClubMessageView, ClubEventsView, routesView

  var params = rwgps.Utils.getQueryParameters(window.location.search)
  var viewingArchives = params.archive === 'true'

  ns.onMount = page => {
    $(() => {
      switch (page) {
        case 'events':
          ns.eventsView = new ClubEventsView;
          break;
        case 'routes':
          $.get(`/clubs/${rwgps.clubs.show.clubId}/table_routes.json${viewingArchives ? '?archived=true' : ''}`, routes => {
            routesView = new RoutesView({
              clubId: ns.clubId,
              editable: ns.canManage,
              data: routes,
              tags: ns.routeTags,
              userDateFormat: ns.userDateFormat,
              userPinnedRoutes: ns.userPinnedRoutes,
              hasRouteLink: Object.fromEntries(ns.hasRouteLink.map(key => [key, true])),
              settings: tableSettings("routes", ns.canManage),
              isClubAdmin: ns.isClubAdmin,
              eventCount: ns.eventCount,
              experienceCount: ns.experienceCount,
              collectionCount: ns.collectionCount
            });
            ns.routesView = routesView
            routesView.grid.onRequestError(onError.bind(this))
          })
          break;
        case 'embed_library':
          $.get(`/clubs/${rwgps.clubs.show.clubId}/table_embeds.json`, resp => {
            new EmbedLibraryView({
              clubId: ns.clubId,
              data: resp.embeds,
              editable: ns.canManage,
              userDateFormat: ns.userDateFormat,
              settings: tableSettings("embed_library", true)
            })
          })
          break;
        case 'experiences':
          $.get(`/clubs/${rwgps.clubs.show.clubId}/table_experiences.json${viewingArchives ? '?archived=true' : ''}`, resp => {
            new ExperiencesView({
              clubId: ns.clubId,
              data: resp.experiences,
              editable: ns.canManage,
              userDateFormat: ns.userDateFormat,
              settings: tableSettings("experiences", true)
            })
          })
          break;
        case 'poi_library':
          $.get(`/clubs/${rwgps.clubs.show.clubId}/table_pois.json`, resp => {
            new PoiLibraryView({
              clubId: ns.clubId,
              data: resp.pois,
              editable: ns.canManage,
              poiIcons: resp.poiIcons || [],
              tags: resp.poiTags || [],
              settings: tableSettings("poi_library", true)
            })
          })
          break;
        case 'members':
          if (ns.canManageMembers) {
            $.get(`/clubs/${rwgps.clubs.show.clubId}/table_members.json`, members => {
              ns.membersView = new ClubMembersView({
                clubId: ns.clubId,
                currentMember: ns.currentMember,
                baseCurrentMember: ns.baseCurrentMember,
                data: members,
                settings: tableSettings("members", true)
              })
              ns.membersView.grid.onRequestError(onError.bind(this))
            })
          }
          break;
        case 'messages':
          new ClubMessagesView;
          break;
        case 'settings':
          break;
      }
    })
  }

  ns.onUnmount = page => {
    switch (page) {
      case 'events':
        ns.eventsView = null
        break;
      case 'routes':
        ns.routesView = null
        break;
      case 'members':
        break;
      case 'messages':
        break;
      case 'settings':
        break;
    }
  }

  ns.init = function() {
    $(function(){
      if (!ns.tableSettings) { ns.tableSettings = {} }

      attachRouteInfoModalEvents();

      $("#plan-ride-container").on("show.bs.modal", () => {
        resetNewEventForm()
      })
      $("#new-event-container").on("show.bs.modal", () => {
        resetSimpleEventForm()
      })


      $('#edit-club-message-modal').on('hidden.bs.modal', function(){
        $('#edit-club-message-modal').removeData('bs.modal')
      });

      $('#sendMessageModal').on('shown.bs.modal', function() {
        $('#quick_message').on('submit', function() {
          $('#sendMessageModal').modal('hide');
        });
      });

      $('#sendMessageModal').on('hidden.bs.modal', function(){
        $('#sendMessageModal').removeData('bs.modal')
      });
    });
  }

  function resetSimpleEventForm() {
    $('#simple_event_start_time').hide()
    $('#simple_event_end_time').hide()
    $('#new-event-container input[type=checkbox].all_day').attr('checked', true)
  }

  function resetNewEventForm() {
    $('#event_start_time').hide()
    $('#event_end_time').hide()
    $('#plan-ride-container input[type=checkbox].all_day').attr('checked', true)
    $('#plan-ride-container input[type=checkbox].auto_expire_participants').attr('checked', false)
    $('#plan-ride-container .participant_duration_options').hide()
    $('#plan-ride-container input[type=checkbox].request_email').attr('checked', false)
  }

  function attachRouteInfoModalEvents() {
    $('#info-modal').on('click', '.removeItem', function() {
      const element = this.parentElement;
      $(element).addClass('hide');
      const item_id = $(this).attr('data-id');
      const item_type = $(this).attr('data-type');
      let fieldValue = document.getElementById('remove_'+item_type+'_ids').value;
      if(!fieldValue) {
        fieldValue = [];
      } else {
        fieldValue = fieldValue.split(',');
      }
      var updatedValue = fieldValue.concat(item_id);
      document.getElementById('remove_'+item_type+'_ids').value = updatedValue;
      return false;
    });
    $('#info-modal').on('submit', 'form', function() {
      const routeId = $(this).attr('data-route-id');
      const params = $(this).serialize();
      routesView.updateRoute(routeId, params, () => {
        $.jGrowl('Successfully updated.');
        $("#info-modal").modal('hide');
      })
      return false;
    });
  }

  function replacer(match, p1, p2, p3) {
    return '<a href="'+ p1 +'://'+ p3 +'" target="_blank" rel="nofollow">'+ p3 +'</a>'
  }

  MessageCommentView = Backbone.View.extend({
    template: _.template($('#messageCommentsTemplate').html()),
    tagName: "li",
    initialize: function() {
      this.render();
    },
    events: {
      'mouseover .comment': 'showDeleteIcon',
      'mouseleave .comment': 'hideDeleteIcon',
      'click .delete-comment': 'destroyComment'
    },
    render: function() {
      var comment = this.options.comment.comment.replace(/(\n)/g, " <br> "),
          updatedComment = comment.replace(/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/, replacer);

      this.options.comment.comment = updatedComment;
      this.$el.html(this.template({comment: this.options.comment, message: this.options.message}));
      return this;
    },
    showDeleteIcon: function() {
      if(rwgps.config.currentUser && (this.options.comment.user_id == rwgps.config.currentUser.id || ns.canManageMessages)) {
        this.$('.delete-comment').show();
      }
    },
    hideDeleteIcon: function() {
      this.$('.delete-comment').hide();
    },
    destroyComment: function() {
      // TODO: This should be consolidated with other comment requests
      var id = this.options.comment.id,
          self = this;
      customConfirm("Are you sure you want to delete this comment?", function() {
        $.ajax({
          type: 'POST',
          url: '/comments/'+id+'.json',
          data: {_method: 'delete'},
          dataType: 'json',
          success: function() {
            $.jGrowl("Successfully deleted");
            self.options.message.comment_count--;
            self.options.messageView.renderCommentsCount();
            $(self.el).html('');
          },
          error: function() {
            $.jGrowl("There was an error deleting this comment");
          }
        });
      });
    }
  });

  ClubMessageView = Backbone.View.extend({
    template: _.template($('#clubMessageTemplate').html()),
    tagName: "li",
    className: 'club_message',
    initialize: function() {
      this.render();
    },
    events: {
      'click a.show_comments': 'displayComments',
      'submit': 'addComment',
      'click .edit_message': 'editMessage',
      'click .show_reply': 'showReply'
    },
    render: function() {
      var messageContent = this.options.message.content.replace(/(\n)/g, " <br> "),
           updatedContent = messageContent.replace(/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/, replacer);
      this.options.message.content = updatedContent;
      this.$el.html(this.template({message: this.options.message}));
      this.renderCommentsCount();
      return this;
    },
    renderCommentsCount: function() {
      var showNumComments = this.$('.comment_show');
      if (this.options.message.comment_count == 0) {
        showNumComments.html('').closest('li').css({display: 'none'});
      } else if (this.options.message.comment_count == 1) {
        showNumComments.html(' 1 Comment ').css({display: 'inline-block'});
      } else {
        showNumComments.html(' ' + this.options.message.comment_count + ' Comments ').css({display: 'inline-block'});
      }
    },
    editMessage: function(e) {
      $.get($(e.currentTarget).attr('href'), function(resp) {
        $('#edit-club-message-modal').html(resp).modal();
      });

      return false;
    },
    showReply: function() {
      this.$('.add_comment').toggle();
    },
    addComment: function() {
      // TODO: This should be consolidated with other comment requests
      var $commentsList = this.$('.message-comments-list'),
          comment = this.$('textarea.new_comment').val(),
          that = this;
      if(comment != '') {
        $.ajax({
          url: '/comments.json',
          type: 'POST',
          dataType: 'json',
          data: {comment: comment, response_as_data: true, parent_id: this.options.message.id, parent_type: "club_message"},
          success: function(response) {
            that.options.message.comment_count++;
            that.renderCommentsCount();
            var item = new MessageCommentView({comment: response, message: that.options.message, messageView: that});
            $commentsList.append(item.$el);
          },
          error: function() {
            $.jGrowl("There was an error saving your comment");
          }
        });
      }
      $commentsList.show();
      this.$('textarea.new_comment').val('');
      return false;
    },
    displayComments: function() {
      var $commentsList = this.$('.message-comments-list');
      var that = this;
      if ($commentsList.is(":visible")) {
        $commentsList.hide();
      } else {
        $commentsList.html('');
        $.get('/comments.json', {parent_type: "club_message", parent_id: this.options.message.id}, function(comments) {
          comments.comments.forEach(function(comment) {
            var item = new MessageCommentView({comment: comment, message: that.options.message, messageView: that});
            $commentsList.append(item.$el);
          });
        });
        $commentsList.show();
      }
    }
  });

  ClubMessagesView = Backbone.View.extend({
    el: '#club-messages',
    initialize: function() {
      this.render();
    },
    render: function() {
      var messages = ns.clubMessages,
         $messagesList = this.$('#club-message-list');
      messages = messages.sort(function(a, b) {
        a = new Date(a.created_at);
        b = new Date(b.created_at);
        return a>b ? -1 : a<b ? 1 : 0;
      });

      messages.forEach(function(message) {
        var item = new ClubMessageView({message: message});
        $messagesList.append(item.$el);
      });
      return this;
    }
  });

  ClubEventsView = Backbone.View.extend({
    el: '#club-events',
    initialize: function() {
      var params = rwgps.Utils.getQueryParameters(window.location.search)
      var listMode = params.display === 'list'
      var viewingArchives = params.archive === 'true'

      this.$el.toggleClass('showingArchives', viewingArchives)
      this.$el.toggleClass('showingLibrary', !viewingArchives)

      if ($('#event_list').is(':visible')) {
        this.initListView()
      } else if (listMode) {
        this.showListView();
      }
      window.Clubs.Calendar.init()
    },
    events: {
      'click .toggle-other-events': 'toggleOther',
      'click .show-tbd-events': 'showTbdEvents',
      'click .toggle_list_view': 'showListView',
      'click .toggle_calendar_view': 'showCalendarView',
      'click .create_event': 'createEvent'
    },
    createEvent: function() {
      rwgps.createEventModal()
    },
    initListView: function() {
      var params = rwgps.Utils.getQueryParameters(window.location.search)
      var viewingArchives = params.archive === 'true'

      $.get(`/clubs/${rwgps.clubs.show.clubId}/table_events.json${viewingArchives ? '?archived=true' : ''}`, events => {
        this.listView = new EventsListView({
          editable: ns.canManage,
          data: events,
          userDateFormat: ns.userDateFormat,
          settings: tableSettings("events", ns.canManage)
        });

        this.listView.grid.onRequestError(onError.bind(this))
      })
    },
    showTbdEvents: function() {
      $('.tbd_events').toggle()
    },
    toggleOther: function() {
      $('#other-events').toggle();
    },
    showListView: function() {
      $('#event_calendar').hide();
      $('#event_list').show();
      $('.toggle_list_view').button('toggle')
      if (!this.listView) { this.initListView() }
    },
    showCalendarView: function(){
      $('#event_list').hide();
      $('#event_calendar').show();
    }

  });

  function tableSettings(name, manager = false) {
    const tableName = `${manager ? 'manage' : 'view'}-${name}`
    var saveOpts = null

    if (ns.saveTableSettings) {
      saveOpts = {
        url: `/clubs/${ns.clubId}/update_table_settings`,
        method: 'PUT',
        name: tableName
      }
    }

    return {
      saved: ns.tableSettings[tableName],
      opts: saveOpts
    }
  }

  function onError(errors) {
    var message = ""
    if (errors.length > 0) {
      message = errors.join("<br>")
    } else {
      message = "There was an error performing the requested operation"
    }

    $("#errors-content").html(message + "<br>")
    $("#errors").modal("show")
  }
});



// WEBPACK FOOTER //
// ./public/javascripts/clubs/show.js